import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'app/client/modules/Search/i18n';
import boost from 'app/client/utilities/hoc/boost';
import store from 'app/client/modules/Search/store';

import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Tabs from './components/Tabs';
import Results from './components/Results';
import Footer from './components/Footer';

import useAllowedSearchTypes from './hooks/useAllowedSearchTypes';
import useSearch from './hooks/useSearch';

import * as S from './styled';

const GlobalSearch = ({ search, customerId, isOpen, onClose, initialQuery }) => {
  const { t } = useTranslation();
  const { indexKeys, tabKeys } = useAllowedSearchTypes();

  const {
    refs: { dialogElementRef, searchInputRef },
    state: { query, setQuery, activeTabKey, setActiveTabKey, isSearching, hasSearched },
    results: { visibleGroups, activeResultIndex, setRowElementByIndex },
  } = useSearch({
    t,
    search,
    customerId,
    isOpen,
    onClose,
    initialQuery,
    indexKeys,
    tabKeys,
  });

  return (
    <S.Dialog ref={dialogElementRef} open={isOpen} lightDismiss withoutHeader>
      <Header
        searchInputRef={searchInputRef}
        query={query}
        setQuery={setQuery}
        isSearching={isSearching}
        onClose={onClose}
      />

      <Tabs tabKeys={tabKeys} activeTabKey={activeTabKey} setActiveTabKey={setActiveTabKey} />

      <Results
        visibleGroups={visibleGroups}
        activeResultIndex={activeResultIndex}
        setRowElementByIndex={setRowElementByIndex}
        query={query}
        isSearching={isSearching}
        hasSearched={hasSearched}
        onClose={onClose}
      />

      <Footer t={t} />
    </S.Dialog>
  );
};

GlobalSearch.propTypes = {
  search: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  initialQuery: PropTypes.string,
};

export default boost({
  store,
  i18n,
})(GlobalSearch);
